import React, { useState } from "react";
import PageHero from "@/components/shared/PageHero";
import { EVENTS } from "@/data/mock";
import { MapPin, Calendar, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { SuccessPopup } from "@/components/shared/FormShell";

export default function EventsPage() {
    const [open, setOpen] = useState(false);
    const [chosen, setChosen] = useState(null);
    return (
        <>
            <PageHero
                testId="events-page"
                eyebrow="Register for Events"
                chapter="Service · 04"
                title="Public events."
                subtitle="Register for the closest town hall to your district. Concept prototype — no seat is actually reserved."
            />
            <section className="bg-white py-20 md:py-24">
                <div className="container-x">
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
                        {EVENTS.map((e, i) => (
                            <motion.article
                                key={e.id}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.2 }}
                                transition={{ duration: 0.6, delay: i * 0.08 }}
                                className="group overflow-hidden rounded-[24px] border border-ink/10 bg-white"
                                data-testid={`register-event-${e.id}`}
                            >
                                <div className="relative aspect-[4/3] overflow-hidden">
                                    <img src={e.image} alt={e.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                    <span className="absolute left-4 top-4 rounded-full bg-white px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink">0{i + 1} / 03</span>
                                </div>
                                <div className="flex flex-col gap-3 p-6">
                                    <h3 className="font-display text-[22px] font-semibold leading-tight tracking-tight text-ink">{e.title}</h3>
                                    <div className="flex items-center gap-2 text-[13px] text-slate-500"><Calendar className="h-3.5 w-3.5 text-pink" />{e.date}</div>
                                    <div className="flex items-center gap-2 text-[13px] text-slate-500"><MapPin className="h-3.5 w-3.5 text-pink" />{e.location}</div>
                                    <div className="mt-2 flex items-center justify-between border-t border-ink/10 pt-4">
                                        <div className="text-[12px] uppercase tracking-[0.24em] text-slate-500">
                                            {e.seats} seats remaining
                                        </div>
                                        <button
                                            onClick={() => { setChosen(e); setOpen(true); }}
                                            className="inline-flex items-center gap-1 text-[13px] font-semibold uppercase tracking-[0.22em] text-ink hover:text-pink"
                                            data-testid={`register-btn-${e.id}`}
                                        >
                                            Register <ArrowUpRight className="h-4 w-4" />
                                        </button>
                                    </div>
                                </div>
                            </motion.article>
                        ))}
                    </div>
                </div>
            </section>
            <SuccessPopup
                open={open}
                onClose={() => setOpen(false)}
                title={chosen ? `Registered for ${chosen.title}` : "Registered"}
                body={chosen ? `Your seat is reserved for ${chosen.date} at ${chosen.location}. This is a concept confirmation.` : "Your seat is reserved."}
                code={`EVT-${Math.floor(10000 + Math.random() * 90000)}`}
            />
        </>
    );
}
